import React from "react";
import { SearchRecordTile } from "./SearchRecordTile";

export function SearchResultsTiles({
  records,
  setSelectedRecord,
}: {
  records: any;
  setSelectedRecord: (record: any) => void;
}) {
  console.log(records);
  return (
    <div className="searchResultsTilesContainer">
      {records.records.records.map((record: any) => (
        <SearchRecordTile
          record={record}
          setSelectedRecord={setSelectedRecord}
        />
      ))}
    </div>
  );
}
